import * as CommonUtils from '../../../../../utils/common';
import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(r3, r4) {
  var result = Complex.createComplex(-1 * CommonUtils.parallel(r3, r4), 0);
  return result;
}

export function computeComplexFF(complexRParallel, r3, r4) {
  var complexR3 = Complex.createComplex(r3, 0);
  var result = complexR3.mult(complexRParallel.divide(Complex.createComplex(r3 + r4, 0)));
  return result;
}
